export type LanguageKeyType = "sv" | "no" | "en";

export type LanguageType = {
    langKey: LanguageKeyType,
    name: string
}

const languages: LanguageType[] = [
    { langKey: "sv", name: "Svenska" },
    { langKey: "no", name: "Norska" },
    { langKey: "en", name: "Engelska" }
]

export const useLanguages = () => {

    return {
        allLanguages: languages,
        additionalLanguages: languages.filter(m => m.langKey !== "sv"),
    }
}